import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-valorant-solo-normal-games',
  templateUrl: './valorant-normal-games.component.html'
})
export class ValorantNormalGamesComponent {
  service = 'normalgames';
  availableServices = services['valorant'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'valorant',
    service: 'normalgames',
    type: 'solo',
    title: {
      en: 'Unrated Wins',
    },
    subtitle: {
      en: 'Guaranteed Unrated Wins in Solo or Duo Boosting',
      fr: 'Victoires garanties en parties non classées en Solo ou Duo Boosting',
      de: 'Garantierte Siege in ungewerteten Spielen im Solo- oder Duo-Boosting',
      pt: 'Vitórias garantidas em jogos unrated em Solo ou Duo Boosting',
      es: 'Victorias garantizadas en partidas no clasificadas tanto en Solo como en Duo Boosting',
    },
    start: 9,
    desired: 10,
    serviceName: {
      en: 'Wins',
      de: 'Siege',
    },
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is An Unrated Win Boosting Service?",
        answer: "A Unrated Win in a non-ranked service that guarantees a predetermined number of unrated wins."
      },
      {
        question: "Do Losses Count Towards Order Progression?",
        answer: "Only wins are counted, therefore when you purchase 10 Unrated Wins, you are guaranteed to have played at least 10 games."
      },
      {
        question: "Can I Use This Service To Secure Battle Pass Levels Or Agent Contract Levels?",
        answer: "Yes, you can. As long as the service is active we will try to complete as many levels as possible."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Agents?",
        answer: "Yes, you can. Click the \"Choose your Agents\" button in the order customization menu to make it happen."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de boosting de victoires non-classé?",
        answer: "Une victoire non-classée est un service non-classé qui garantit un nombre prédéterminé de victoires en non-classé."
      },
      {
        question: "Les défaites sont-elles prises en compte dans la progression des commandes?",
        answer: "Seuls les victoires sont prises en compte. Par conséquent, lorsque vous achetez 10 victoires normales, vous avez la garantie d\'avoir joué au moins 10 parties."
      },
      {
        question: "Puis-je utiliser ce service pour assurer les niveaux du passe de combat ou les niveaux de contrat d\'agent?",
        answer: "Oui, c\'est possible. Tant que le service sera actif, nous essaierons de compléter le plus grand nombre de niveaux possible."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes agents préférés?",
        answer: "Oui, vous le pouvez. Cliquez sur le bouton \"Choisissez vos agents\" dans le menu de personnalisation de la commande pour y parvenir."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Unrated Win Boosting Service?",
        answer: "Ein Unrated-Win ist ein nicht gewerteter Service, der eine festgelegte Anzahl an Unrated-Siegen garantiert."
      },
      {
        question: "Zählen Verluste für den Bestellfortschritt?",
        answer: "Es werden nur Siege gezählt. Wenn du also 10 Unrated Wins kaufst, hast du garantiert mindestens 10 Spiele gespielt."
      },
      {
        question: "Kann ich diesen Service nutzen, um mir Battle-Pass-Stufen oder Agentenvertragsstufen zu sichern?",
        answer: "Ja, das kannst du. Solange der Dienst aktiv ist, werden wir versuchen, so viele Level wie möglich abzuschließen."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Kann ich meine bevorzugten Agenten auswählen?",
        answer: "Ja, das kannst du. Klicke auf die Schaltfläche \"Wähle deine Agenten\" im Menü zur Bestellungsanpassung, um dies zu tun."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Unrated Wins Boosting?",
        answer: "Unrated Wins é um serviço exclusivo para jogos não ranked que garante uma quantidade predeterminada de vitórias."
      },
      {
        question: "As derrotas contam para a progressão do pedido?",
        answer: "Apenas as vitórias são contadas, portanto, quando compras 10 Unrated Wins, tens a garantia de que são jogados pelo menos 10 jogos."
      },
      {
        question: "Posso Usar Este Serviço Para Garantir Níveis Do Battle Pass Ou Agent Contracts?",
        answer: "Sim, podes. Enquanto o serviço estiver ativo, tentaremos completar o máximo possível de níveis."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso, vai até o menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso escolher meus agents preferidos?",
        answer: "Sim, podes. Clica no botão \"Escolhe os teus Agents\" no menu de personalização do pedido para isso acontecer."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost sin calificación?",
        answer: "Una Unrated Win en un servicio no clasificado que garantiza un número predeterminado de victorias no clasificadas."
      },
      {
        question: "¿Cuentan las pérdidas para la progresión de la orden?",
        answer: "Sólo se contabilizan las victorias, por lo que al comprar 10 Unrated Wins, se te garantiza haber jugado al menos 10 partidas."
      },
      {
        question: "¿Puedo utilizar este servicio para asegurar niveles de pase de batalla o niveles de contrato de agente?",
        answer: "Sí que se puede. Mientras el servicio esté activo intentaremos completar tantos niveles como sea posible."
      },
      {
        question: "¿Puedo jugar con el Booster In Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir a mis agentes preferidos?",
        answer: "Sí, puedes hacerlo. Haz clic en el botón \"Elige tus Agentes\" en el menú de personalización del pedido."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Valorant Boosting - Unrated Wins Boosting for Valorant",
      fr: "Boosting Valorant - Boosting de Victoires en non-classé sur Valorant",
      de: "Valorant Boosting - Unrated Wins Boosting für Valorant",
      pt: "Valorant Boosting - Boost de Vitórias Não Classificadas para Valorant",
      es: "Valorant Boosting - Boost de victorias sin calificación para Valorant",
    },
    metaDescription: {
      en: "Looking to improve your unraked MMR in Valorant? Our affordable, fast, and secure service will help you queue against better players and test your skill",
      fr: "Vous cherchez à améliorer votre MMR sur Valorant ? Notre service abordable, rapide et sécurisé vous aidera à vous confronter contre de meilleurs joueurs et à tester vos compétences",
      de: "Willst du deine MMR in Valorant verbessern? Mit unserem erschwinglichen, schnellen und sicheren Service kannst du gegen bessere Spieler antreten und deine Fähigkeiten testen.",
      pt: "Desejas melhorar o teu MMR unrated no Valorant? O nosso serviço acessível, rápido e seguro ajudar-te-á a enfrentar jogadores melhores e testar as tuas habilidades.",
      es: "¿Quieres mejorar tu MMR en Valorant? Nuestro servicio asequible, rápido y seguro te ayudará a hacer cola contra mejores jugadores y poner a prueba tu habilidad.",

    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}